import { render, staticRenderFns } from "./Carregamento.vue?vue&type=template&id=72cf4ed8&scoped=true&"
import script from "./Carregamento.vue?vue&type=script&lang=js&"
export * from "./Carregamento.vue?vue&type=script&lang=js&"
import style0 from "./Carregamento.vue?vue&type=style&index=0&id=72cf4ed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cf4ed8",
  null
  
)

export default component.exports